import { Collapse, Typography, Card, Space, Divider, Descriptions } from "antd";
import { API_BASEURL } from "../../config/StaticConfig";

const { Panel } = Collapse;
const { Text } = Typography;

interface Props {
  apiToken: String;
}

export function PortalApiDoc({ apiToken }: Props) {
  return (
    <Card title="Documentation" className={"card-body"} style={{ flex: 1 }}>
      <Collapse bordered={true} defaultActiveKey={["1"]} style={{ borderRadius: 10 }}>
        {/* HTTP header setup */}
        <Panel header="Setup" key="1">
          <Space direction="vertical" style={{ padding: 10 }}>
            <Descriptions column={1} title="HTTP Header">
              <Descriptions.Item>
                <Text copyable code>
                  Authorization: Bearer {apiToken}
                </Text>
              </Descriptions.Item>
            </Descriptions>
            <Descriptions column={1} title="API base url">
              <Descriptions.Item>
                <Text copyable code>
                  {`${API_BASEURL}/api/`}
                </Text>
              </Descriptions.Item>
            </Descriptions>
          </Space>
        </Panel>

        {/* Portal API endpoints */}
        <Panel header="Portal API endpoints" key="2">
          <Space direction="vertical" style={{ padding: 10 }}>
            <Descriptions column={1} title="Get subgraph list">
              <Descriptions.Item label="Method">GET</Descriptions.Item>
              <Descriptions.Item label="Endpoint">
                <Text copyable code>
                  /api/subgraphs
                </Text>
              </Descriptions.Item>
            </Descriptions>
            <Divider />
            <Descriptions column={1} title="Get subgraph status by ID">
              <Descriptions.Item label="Method">GET</Descriptions.Item>
              <Descriptions.Item label="Endpoint">
                <Text copyable code>
                  /api/subgraphs/:subgraphIdentifier/status
                </Text>
              </Descriptions.Item>
              <Descriptions.Item label="subgraphIdentifier">
                {`a field "identifier" in subgraph list API (Note: identifier needs to do URL encode, "/" to "%2F")`}
              </Descriptions.Item>
            </Descriptions>
            <Divider />
            <Descriptions column={1} title="Get subgraph logs">
              <Descriptions.Item label="Method">GET</Descriptions.Item>
              <Descriptions.Item label="Endpoint">
                <Text copyable code>
                  /subgraphs/:subgraphDeploymentId/logs
                </Text>
              </Descriptions.Item>
              <Descriptions.Item label="subgraphDeploymentId">
                a field "subgraph" in subgraph status API
              </Descriptions.Item>
              <Descriptions.Item label="Query param"> </Descriptions.Item>
              <Descriptions.Item label="level">
                <Text copyable code>
                  info/debug/warn/error
                </Text>
              </Descriptions.Item>
              <Descriptions.Item label="query">search log keywords</Descriptions.Item>
            </Descriptions>
          </Space>
        </Panel>
      </Collapse>
    </Card>
  );
}
